import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import Dashboard from './dashboard/dashboard';
import Deposit from './deposit/deposit';
import Deposit2 from './deposit2/deposit';
import Overview from './overview/overview';
import Withdrawal from './withdrawal/withdrawal';
import Productwallet from './productwallet/productwallet';
import Peertopeer from './peertopeer/peertopeer';
import Outstandingbet from './outstandingbet/outstandingbet';
import Bethistory from './bethistory/bethistory';
import BetOverview from './betoverview/betoverview';

import CustomerComponent from './customer.component';

let customerModule = angular.module('pages.customer', [
  Dashboard,
  Deposit,
  Deposit2,
  Overview,
  Withdrawal,
  Productwallet,
  Peertopeer,
  Outstandingbet,
  Bethistory,
  BetOverview,
])
.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';
  $stateProvider
  .state('customer', {
    parent: 'standardLayout',
    url: '/customer',
    component: 'customer',
    })
  ;
})
.component('customer', CustomerComponent)
.name;

export default customerModule;



// WEBPACK FOOTER //
// ./client/app/pages/customer/customer.module.js